import _ from 'lodash';
import { CargoDetail } from '../consult';
import { FormControl } from '@angular/forms';
import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import * as SelectFX from 'periodicjs.component.selectfx';
declare var $:any;
import bigdecimal from 'bigdecimal';

@Component({
  selector: 'fcl-cargoinfo',
  templateUrl: 'fcl-cargoinfo.html',
})
export class FclCargoinfoComponent implements AfterViewInit {
  @Input() cargo: CargoDetail;
  @Input() crncyList: Array<string>;
  
  @Output() onCrgoTpSelect:EventEmitter<string> = new EventEmitter();
  @Output() delCargo = new EventEmitter();
  
  @ViewChild('commodityInput') commodityInput:ElementRef;

  showTooltip : boolean = false;
  showCountTooltip: boolean = false;

  ngAfterViewInit(): void {
  }

  countChange(event) {
    this.cargo.count = event.target.value;
  }

  handleCargoTpSelect(cargoTp) {
    this.cargo.crgoTp = cargoTp;
    if(cargoTp == 'OT' || cargoTp == 'FR' || cargoTp == 'OTHER') {
      this.cargo.crgoSz = this.cargo.crgoSz == "HC" ? null : this.cargo.crgoSz;
    }
    this.onCrgoTpSelect.emit(this.cargo.crgoTp);
  }
  
  cargoSizeChange(event) {
    this.cargo.crgoSz = event;
  }

  cargoweightChange(event) {
    let weight = event.target.value;
    this.cargo.weight = weight.replace(/[^0-9\.]/g, '');
    if (!this.cargo.wghtUnit) this.cargo.wghtUnit = 'kg'; // 08/23 중량 입력시 'kg'로 설정
  }

  volUnitChange(event) {
    this.cargo.volUnit = event;
  }

  cargovalueChange(event) {
    let value = event.target.value;
    this.cargo.value = value.replace(/[^0-9\.]/g, '');
  }

  valueUnitChange(event) {
    this.cargo.valueUnit = event;
  }

  deleteCargo() {
    this.delCargo.emit(this.cargo);
  }

  focusShowTooltip($event) {
    this.showTooltip = true;
  }

  focusHideTooltip($event) {
    this.showTooltip = false;
  }


  focusShowCountTooltip($event) {
    this.showCountTooltip = true;
  }

  focusHideCountTooltip($event) {
    this.showCountTooltip = false;
  }


  setComodity(event:any){
    this.cargo.commodity = this.commodityInput.nativeElement.value;
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/consult/consult-sub/fcl-cargoinfo.ts